var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wechat-content"},[_c('div',{staticClass:"form"},[_c('Input',{attrs:{"title":"微信号","desc":"微信号仅分桐负责人可见","placeholder":"请输入微信号"},model:{value:(_vm.wechat),callback:function ($$v) {_vm.wechat=$$v},expression:"wechat"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }